var _path, _path2;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgUnstoppable(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 21.9412L27.127 1.87598V10.8371L0 21.9412Z",
    fill: "#72E6FC"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.86963 11.01V17.331C4.86963 22.1188 8.75085 26 13.5386 26C18.3263 26 22.2075 22.1187 22.2075 17.331V1L16.0712 4.54282V17.6239C16.0712 19.2915 14.7193 20.6434 13.0517 20.6434C11.384 20.6434 10.0321 19.2915 10.0321 17.6239V8.02947L4.86963 11.01Z",
    fill: "#4B47EE"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnstoppable);
export default __webpack_public_path__ + "static/media/unstoppable.c3cbeb1235bf1820ce7f10c305ae4eb1.svg";
export { ForwardRef as ReactComponent };